import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { OrbitControls, Environment } from '@react-three/drei';

function RotatingCube() {
    const meshRef = useRef();

    useFrame((state, delta) => {
        if (meshRef.current) {
            meshRef.current.rotation.x += delta * 0.5;
            meshRef.current.rotation.y += delta * 0.5;
        }
    });

    return (
        <mesh ref={meshRef}>
            <boxGeometry args={[2, 2, 2]} />
            <meshStandardMaterial 
                color="#00ff88" 
                metalness={0.5}
                roughness={0.2}
            />
        </mesh>
    );
}

export default function Cube() {
    return (
        <>
            <ambientLight intensity={0.5} />
            
            <directionalLight 
                position={[5, 5, 5]} 
                intensity={1}
                castShadow
            />
            
            <pointLight position={[-5, -5, -5]} color="#ff6b6b" intensity={0.5} />
            
            <RotatingCube />
            
            <OrbitControls 
                enableDamping 
                dampingFactor={0.05}
                minDistance={3}
                maxDistance={10}
            />
            
            <Environment preset="sunset" />
        </>
    );
}

